import React, { useState } from "react";

import { useGlobalContext } from "context/GlobalContext";
import { useParams } from "react-router-dom";

import { avatargroupTokenTabData } from "assets/data/tokenTabData";
import { getComponentsSideData } from "assets/data/sideTabData";

import DesignSystemLayout from "components/DesignSystemPage/DesignSystemLayout";
import PreviewAvatarGroupComponent from "components/DesignSystemPage/AvatarGroupComponent/PreviewAvatarComponent";
import UsageAvatarGroupComponent from "components/DesignSystemPage/AvatarGroupComponent/UsageAvatarGroupComponent";
import TokenTableComponent from "components/Common/TokenTableComponent/TokenTableComponent";

import "assets/scss/pages/_DesignSystemComponents.scss";

const AvatarGroupComponents = () => {
  const { id } = useParams();

  const { designSystemMeta, designSystem } = useGlobalContext();

  const componentName = "avatargroup";
  const componentKey = `Component/${componentName}`;
  const componentData = designSystem[componentKey];
  const tokenTableData = avatargroupTokenTabData(componentData, componentName);

  const tabData = ["Default"];
  const [activeTab, setActiveTab] = useState(0);
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabClick = (index) => {
    setActiveTab(index);
  };
  const bannerData = {
    heading: "Avatar Group",
    description:
      "Add, replace, generate colors which makes your design looks awesome!",
    bannerImage: designSystemMeta.banner_url,
  };
  const tabs = ["Preview", "Usage", "Tokens"];

  const renderContent = () => {
    switch (selectedTab) {
      case 0:
        return (
          <PreviewAvatarGroupComponent
            tabData={tabData}
            activeTab={activeTab}
            handleTabClick={handleTabClick}
            setSelectedTab={setSelectedTab}
          />
        );
      case 1:
        return (
          <div>
            <UsageAvatarGroupComponent />
          </div>
        );
      case 2:
        return <TokenTableComponent tokenTableData={tokenTableData} />;
      default:
        return null;
    }
  };
  return (
    <DesignSystemLayout
      bannerData={bannerData}
      selectedTab={selectedTab}
      setSelectedTab={setSelectedTab}
      tabs={tabs}
      sideTabs={getComponentsSideData(id)}
      title="Components"
    >
      {renderContent()}
    </DesignSystemLayout>
  );
};

export default AvatarGroupComponents;
